@if (loading) {
  <div style="width: 100%;text-align: center;">
    <div style="display:flex;justify-content: center;align-items: center"><mat-spinner></mat-spinner></div><br>
  </div>
}
<div class="btn-div">
  <button mat-button class="btn-export" (click)="exportData()"><mat-icon slot="start">download</mat-icon> Export</button>
</div>
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8 tableOfUsers" matSort>
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
    <td mat-cell *matCellDef="let element"> {{element.email}} </td>
  </ng-container>

  <ng-container matColumnDef="data">
    <th mat-header-cell *matHeaderCellDef> Data </th>
    <td mat-cell *matCellDef="let element">
      @for (activity of element.activities; track activity.aid) {
        <mat-icon matTooltip="{{activity.name}}" style="{{Helper.getActivityColor(activity.state)}}" slot="start">{{Helper.getActivityIcon(activity.type)}}</mat-icon>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef> Detail </th>
    <td mat-cell *matCellDef="let element"> <button mat-icon-button (click)="goToUser(element.id)"><mat-icon>manage_accounts</mat-icon></button></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<br>
<div class="legend">
  <mat-icon style="color:red;">brightness_1</mat-icon> = Neotevřeno
  <mat-icon style="color:orange;">brightness_1</mat-icon> = V průběhu
  <mat-icon style="color:green;">brightness_1</mat-icon> = Kompletní
</div>
